var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2474 14.0504C22.8337 14.0504 23.0784 13.2972 22.6022 12.9499L15.3563 7.67919C15.2528 7.60337 15.1279 7.5625 14.9996 7.5625C14.8713 7.5625 14.7464 7.60337 14.6429 7.67919L7.39706 12.9499C6.92083 13.2953 7.16558 14.0504 7.75375 14.0504H8.9282V21.1464H7.56212C7.47864 21.1464 7.41034 21.2147 7.41034 21.2982V22.2848C7.41034 22.3682 7.47864 22.4366 7.56212 22.4366H22.4371C22.5206 22.4366 22.5889 22.3682 22.5889 22.2848V21.2982C22.5889 21.2147 22.5206 21.1464 22.4371 21.1464H21.0711V14.0504H22.2474ZM14.9996 9.0168L20.1433 12.7583H9.85599L14.9996 9.0168ZM10.2943 14.0504H12.5141V21.1464H10.2943V14.0504ZM13.8802 14.0504H16.1001V21.1464H13.8802V14.0504ZM19.705 21.1464H17.4661V14.0504H19.705V21.1464Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancial);
export default __webpack_public_path__ + "static/media/financial.7970fa22a316a78efdfb9284a22f1e5b.svg";
export { ForwardRef as ReactComponent };